<!--
� 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
-->

<section class="dialog-content">
	<h2 mat-dialog-title>
		@if (isIconVisible) {
			<span [ngClass]="['icon-' + iconName]"></span>
		}
		{{ title }}
	</h2>

	<mat-dialog-content>
		@if (message) {
			<span>{{ message }}</span>
		} @else {
			@if (content) {
				<ng-container [ngTemplateOutlet]="content" />
			} @else {
				@if (customComponent) {
					<ng-container
						*ngComponentOutlet="customComponent; inputs: customComponentInputs"
					/>
				}
			}
		}
	</mat-dialog-content>

	<mat-dialog-actions>
		@if (type === "info") {
			<globalictcc-button
				[label]="closeBtnText"
				(handleClick)="close()"
			/>
		} @else {
			<div class="dialog-actions">
				<globalictcc-button
					[label]="cancelBtnText"
					color="secondary"
					(handleClick)="close()"
				/>

				<globalictcc-button
					[label]="confirmBtnText"
					[disabled]="isConfirmActionDisabled()"
					(handleClick)="confirm()"
				/>
			</div>
		}
	</mat-dialog-actions>
</section>
